<app-toaster class="toaster" [config]="toasterService.toaster"></app-toaster>
<div class="container" style="padding: 16px;">
  <mat-toolbar class="toolbar-border" style="justify-content: center;">{{ actionTitle }} Redeem Rule</mat-toolbar>

  <div class="flex-row margin-y-10">
    <label class="bold">City<span class="required-asterisk">*</span></label>
    <small class="text-muted">(Select a city to fetch modes)</small>
    <ng-select [items]="cities" bindLabel="name" placeholder="Select city" [(ngModel)]="selectedCity"
      (change)="onCityChange($event)">
    </ng-select>
  </div>

  <div class="flex-row margin-y-10">
    <label class="bold">Mode</label>
    <small class="text-muted">(Select a city first to load modes)</small>
    <ng-select [items]="modes" bindLabel="name" placeholder="Select mode" [(ngModel)]="selectedMode"
      [compareWith]="compareModeById" (change)="onModeChange($event)" [disabled]="!selectedCity">
    </ng-select>
  </div>

  <div class="flex-row margin-y-10">
    <label class="bold">Shift</label>
    <small class="text-muted">(Select a mode first to load shifts)</small>
    <ng-select [items]="shifts" [multiple]="true" placeholder="Select shift" [(ngModel)]="rule.shift"
      [disabled]="!selectedMode" (change)="onShiftChange()"></ng-select>
  </div>

  <div class="flex-row margin-y-10" *ngIf="isShiftScoped"
    style="background:#fff4f4; border:1px solid #f3c2c2; border-radius:4px; padding:10px;">
    <mat-checkbox [(ngModel)]="blockRedeem" (change)="onBlockRedeemChange()" color="warn">
      Block Redeem for this shift
    </mat-checkbox>
    <small class="text-muted" style="display:block; margin-top:4px;">
      This will block redeem (manual &amp; auto) for this shift, and the other fields will be set to
      defaults automatically with the transaction count forced to 0.
    </small>
  </div>

  <div class="flex-row margin-y-10">
    <label class="bold">Week Days<span class="required-asterisk">*</span></label>
    <ng-select [items]="weekDays" [multiple]="true" placeholder="Select week days" [(ngModel)]="rule.weekDays"
      [disabled]="blockRedeem"></ng-select>
  </div>

  <div class="flex-row margin-y-10" style="margin-top: 15px;">
    <label class="bold">Type<span class="required-asterisk">*</span></label>
    <label *ngFor="let period of transactionPeriods" style="margin-left: 28px; margin-right: 8px;">
      <input type="radio" name="transactionPeriod" [value]="period" [(ngModel)]="rule.transactionPeriod"
        [disabled]="blockRedeem" style="margin-right: 6px;" />
      {{ period | titlecase }}
    </label>
  </div>

  <div class="flex-row margin-y-10">
    <label class="bold">No of Transactions<span class="required-asterisk">*</span></label>
    <input type="number" class="form-control" [(ngModel)]="rule.transactionCount" [disabled]="blockRedeem" />
    <small *ngIf="blockRedeem" class="text-muted">Forced to 0 — redeem is blocked.</small>
  </div>

  <div class="flex-row margin-y-10">
    <label class="bold">Min Transaction Amount<span class="required-asterisk">*</span></label>
    <input type="number" class="form-control" [(ngModel)]="rule.minTransactionAmount" [disabled]="blockRedeem" />
  </div>

  <div class="flex-row margin-y-10">
    <label class="bold">First Redeem Min Amount</label>
    <input type="number" class="form-control" [(ngModel)]="rule.firstRedeemMinAmount" [disabled]="blockRedeem" />
  </div>

  <div class="flex-row margin-y-10">
    <label class="bold">Start Date<span class="required-asterisk">*</span></label>
    <div (click)="openStartDatePicker()">
      <input #startDateInput type="date" class="form-control" [min]="today" [(ngModel)]="rule.startDate"
        [disabled]="blockRedeem" />
    </div>
  </div>

  <div class="flex-row margin-y-10">
    <label class="bold">Terms &amp; Conditions<span class="required-asterisk">*</span> (Use ; (semicolon) to add more than one point. Eg : tnc 1; tnc 2; tnc 3)</label>
    <input type="text" class="form-control" placeholder="Terms and conditions" [(ngModel)]="rule.tnc"
      [disabled]="blockRedeem" />
  </div>

  <div class="flex-row margin-y-10">
    <mat-checkbox [(ngModel)]="rule.active" color="primary">Active</mat-checkbox>
  </div>

  <div class="margin-y-10" *ngIf="!blockRedeem">
    <label class="bold">Auto approval rules (Variable - Operator - Value)</label>
    <span style="color:red">
      <small> Don't enter negative values for Redeem Amount, Number of orders and Total Kilometers</small>
    </span>
    <div class="margin-y-10">
      <button mat-stroked-button type="button" (click)="addNewRule()">
        <mat-icon>add</mat-icon> New set
      </button>
    </div>

    <div *ngFor="let key of ruleSetKeys(); let si = index" style="padding: 10px 0;">
      <div style="font-weight: bolder; padding-bottom: 10px;">
        SET {{ si + 1 }}
        <button mat-stroked-button color="warn" type="button" (click)="deleteRuleSet(key)">
          <mat-icon>delete</mat-icon> Delete Set
        </button>
      </div>

      <div *ngFor="let row of multiAutoRulesSet[key]; let ri = index" class="margin-y-10"
        style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
        <button mat-icon-button color="warn" type="button" (click)="removeRule(key, ri)">
          <mat-icon>delete</mat-icon>
        </button>

        <ng-select style="min-width: 220px;" [items]="variableList" bindLabel="name" bindValue="value"
          placeholder="rule" [(ngModel)]="row.variable" (change)="changeInVariable(key, ri)"></ng-select>

        <ng-select style="min-width: 140px;" *ngIf="row.variable !== 'isFirstRedeem'"
          [items]="operatorList" bindLabel="name" bindValue="value" placeholder="condition"
          [(ngModel)]="row.operator"></ng-select>
        <input *ngIf="row.variable === 'isFirstRedeem'" type="text" class="form-control" value="True/False" disabled
          style="width: 140px;" />

        <input *ngIf="row.variable !== 'isFirstRedeem' && row.operator !== 'between'" type="number"
          class="form-control" placeholder="value" [(ngModel)]="row.value" style="width: 160px;" />
        <ng-select style="min-width: 120px;" *ngIf="row.variable === 'isFirstRedeem'"
          [items]="booleanValues" bindLabel="name" bindValue="value" placeholder="value"
          [(ngModel)]="row.value"></ng-select>

        <input *ngIf="row.operator === 'between'" type="number" class="form-control" placeholder="min"
          [(ngModel)]="row.value" style="width: 110px;" />
        <input *ngIf="row.operator === 'between'" type="number" class="form-control" placeholder="max"
          [(ngModel)]="row.maxValue" style="width: 110px;" />
      </div>

      <div class="margin-y-10">
        <button mat-stroked-button type="button" (click)="addRule(key)">
          <mat-icon>add</mat-icon> Auto approval rule
        </button>
      </div>
    </div>
  </div>

  <div class="margin-y-10">
    <button mat-raised-button class="btn-primary" type="button" [disabled]="disableSubmit" (click)="save()">Submit</button>
  </div>
</div>
